/* import __COLOCATED_TEMPLATE__ from './finish.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

export default class FinishTimingComponent extends Component
{
	@service ajax;
	@service socketGuru;

	@tracked selectedBibRecord = null;
	@tracked selectedFinishImpulseForBibRecord = null;

	@tracked selectedFinishPlungerImpulseRecord = null;
	@tracked selectedFinishImpulseRecord = null;

	constructor()
	{
		super(...arguments);

		// Bind WebSocket event handler
		this._boundHandleSocketEvent = this._handleSocketEvent.bind(this);
		this.socketGuru.events.addEventListener('newEvent', this._boundHandleSocketEvent);

		// Fetch initial auto-association state from backend
		this.fetchAutoAssociationStatus();
	}

	willDestroy()
	{
		this.socketGuru.events.removeEventListener('newEvent', this._boundHandleSocketEvent);
		super.willDestroy();
	}

	/**
	 * Fetch current auto-association status from backend
	 */
	async fetchAutoAssociationStatus()
	{
		if (!this.args.event) {
			return;
		}

		try {
			const eventId = this.args.event.id;
			const response = await this.ajax.request(`/events/${eventId}/autoAssociation/finish/status`);

			// Update local state to match backend
			this.args.event.set('shouldAutoAssociateFinish', response.isRunning);
		} catch (error) {
			console.error('Error fetching finish auto-association status:', error);
		}
	}

	/**
	 * Handle WebSocket events
	 */
	_handleSocketEvent(event)
	{
		const { eventName, data } = event.detail;

		if (eventName === 'autoAssociationStateChanged') {
			this.handleAutoAssociationStateChange(data);
		}
	}

	/**
	 * Handle auto-association state change from WebSocket
	 */
	handleAutoAssociationStateChange(payload)
	{
		if (!this.args.event) {
			return;
		}

		const data = JSON.parse(payload);

		// Only update if this is for our event, 'finish' type, and no typeId
		// Convert both to strings for comparison to handle type mismatches
		if (String(data.eventId) === String(this.args.event.id) &&
		    data.type === 'finish' &&
		    data.typeId === null) {
			this.args.event.set('shouldAutoAssociateFinish', data.isRunning);
			console.log(`✓ Finish auto-association state updated for event ${data.eventId}: ${data.isRunning}`);
		}
	}

	@action
	bibRecordClicked(timingRecord)
	{
		this.selectedBibRecord = timingRecord;
	}

	@action
	finishImpulseForBibRecordClicked(timingRecord)
	{
		this.selectedFinishImpulseForBibRecord = timingRecord;
	}

	@action
	finishPlungerImpulseRecordClicked(timingRecord)
	{
		this.selectedFinishPlungerImpulseRecord = timingRecord;
	}

	@action
	finishImpulseRecordClicked(timingRecord)
	{
		this.selectedFinishImpulseRecord = timingRecord;
	}

	@action
	async toggleAutoAssociate()
	{
		if (!this.args.event) {
			return;
		}

		const eventId = this.args.event.id;
		const currentStatus = this.args.event.shouldAutoAssociateFinish;

		try {
			if (currentStatus) {
				// Stop auto-association
				await this.ajax.post(`/events/${eventId}/autoAssociation/finish/stop`);
			} else {
				// Start auto-association
				await this.ajax.post(`/events/${eventId}/autoAssociation/finish/start`);
			}

			// State will be updated via WebSocket event
		} catch (error) {
			console.error('Error toggling finish auto-association:', error);

			// Optionally: show error to user or revert optimistic update
		}
	}
}

